import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Common/Header";
import { Card, Button, Affix, Form } from "antd";
import { isMobileView } from "../../../Common/AppHelper";
import { useParams, useNavigate } from "react-router-dom";
import AddDetailsForm from "./AddDetailsForm";
import { hasPermission } from "../../../../utils/functions";
import { LOCAL_INVOICE_CREATE_PERMISSION } from "../../../../routes/permissions";

export default function AddIou(props) {
  // Props
  const { width } = props;

  // Antd
  const propertyFormRef = useRef(null);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  // States
  const [loading, setLoading] = useState(false);

  // Router
  const { supplierType } = useParams();

  useEffect(() => {
    if (supplierType == "local" && !hasPermission([LOCAL_INVOICE_CREATE_PERMISSION])) {
      navigate(`/import/details/1`);
    }
  }, [supplierType, navigate]);

  const handleSave = () => {
    if (!loading) {
      form.submit();
    }
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="Import Shipment Status"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Affix offsetTop={20} key="save-action">
                <Button size="small" type="primary" loading={loading} disabled={loading} onClick={handleSave}>
                  Save
                </Button>
              </Affix>,
            ]}
          />
        </Card>
      </Affix>
      <AddDetailsForm ref={propertyFormRef} form={form} setLoading={setLoading} loading={loading} supplierType={supplierType} />
    </>
  );
}
